import { gql } from '@apollo/client';

// IB-1886: org admins create a dashboard in their organisation's Metabase collection (chosen by the server)
export const CREATE_METABASE_DASHBOARD = gql`
  mutation CreateMetabaseDashboard($input: CreateMetabaseDashboardInput!) {
    createMetabaseDashboard(input: $input) {
      id
      name
      collectionId
    }
  }
`;

export type CREATE_METABASE_DASHBOARDType = {
  createMetabaseDashboard: {
    id: number;
    name: string;
    collectionId: number;
  };
};
